import AppLayout from '@components/layouts/appLayout';
import { parseVideo } from '@utils/video';

import { StoryFooter } from '../components/layout/StoryFooter';
import { StoryHeader } from '../components/layout/StoryHeader';
import { StoryWrapper } from '../components/layout/StoryWrapper';
import VideoPlayer from '../components/video/VideoPlayer';
import { VideoPlayerProvider } from '../contexts/VideoPlayerContext';
import { StoryPageDisplay, StoryPageType } from '../enums';
import { Renderer as RendererType, Tester } from '../types';

export const Renderer: RendererType = ({ story, storyPage }) => {
    const { poster, sources } = parseVideo(storyPage.media);
    return (
        <VideoPlayerProvider storyPage={storyPage}>
            <AppLayout
                footerPosition='absolute'
                headerPosition='absolute'
                footerHasPointerEvents={false}
                header={
                    <StoryHeader
                        withExit={false}
                        story={story}
                        storyPage={storyPage}
                    />
                }
                body={
                    <StoryWrapper>
                        <VideoPlayer src={sources} poster={poster} />
                    </StoryWrapper>
                }
                footer={
                    <StoryFooter
                        withCtas
                        withNavigationButtons
                        storyPage={storyPage}
                        withVideoPlayerButtons={true}
                    />
                }
            />
        </VideoPlayerProvider>
    );
};

export const tester: Tester = (display, storyPage) => {
    return {
        condition:
            display === StoryPageDisplay.Flow &&
            storyPage.type === StoryPageType.Video &&
            !!storyPage.ctas,
        priority: 7,
    };
};

const rendererWithTester = { renderer: Renderer, tester };

export default rendererWithTester;
